import { useEffect, useState } from "react"
import { delay } from "../../../features/dataFunctions/dataFunctions"
import { useDispatch } from "react-redux"
import { setPathsSearchValue } from "../../../stateManagement/reducers"

const clearButtonIconSrc = require('../../../assets/images/fontAwesomeIcons/xmark-solid.svg').default

export default function RoadsListSearchbar() {
    const dispatch = useDispatch()
    const [inputSearchValue, setInputSearchValue] = useState<any>('')

    // Изменение значение для поиска

    useEffect(() => {
        const trimmedInputValue = inputSearchValue.trim()
        delay(() => dispatch(setPathsSearchValue((trimmedInputValue))), 300)
    }, [inputSearchValue])

    // Очистка поисковой строки

    useEffect(() => {
        return () => {
            setInputSearchValue('')
            dispatch(setPathsSearchValue((null)))
        }
    }, [])

    function clearSearchValue() {
        setInputSearchValue('')
        dispatch(setPathsSearchValue(('')))
    }

    return (
        <div className="roads-list-searchbar-div">
            <div className="roads-list-searchbar-inputs-div">
                <input
                    id="roads-list-searchbar-input"
                    value={inputSearchValue}
                    onChange={(e: any) => setInputSearchValue(e.target.value)}
                    placeholder="Найти дорогу или направление"
                    autoComplete="off"
                />
                <button className="roads-list-searchbar-clear-button" onClick={clearSearchValue}>
                    <img src={clearButtonIconSrc} />
                </button>
            </div>
        </div>
    )
}
